import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, {TypographyPresentationProps} from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getSubscriptionActiveData from "@TKCCP/Handler/TkccpGetMySubscriptionActiveHandler";
import CustomApplicationState from "@TKCCP/Store/CustomHandlerCreator/CustomApplicationState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    text?: string;
    extendedStyles?: SubscriptionLinkStyles;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        CustomerId: state.context.session.billToId || "",
        UserProfileId: state.context.session.userProfileId || "",
        isAuthenticated: state.context.session.isAuthenticated,
        isSubscriptionActiveFlag:  state.tKCCPData.SubscriptionProductStore?.subscriptionActiveFlag,
        isPunchOutSubFlag: state.context.session?.userRoles?.split(", ").some((val)=>{
            return val === "PunchOut";
        }),        
    };
};

const mapDispatchToProps = {
    getSubscriptionActiveData,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SubscriptionLinkStyles {
    link?: LinkPresentationProps;
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    subscriptionNameGridItem?: GridItemProps;
    yourNameTextField?: TextFieldProps;
    buttonsWrapper?: InjectableCss;
    myActButton?: ButtonPresentationProps;
    editSubButton?: ButtonPresentationProps;
    subscriptionModalHeading?: TypographyPresentationProps;
}

export const SubscriptionLinkStyles: SubscriptionLinkStyles = {
    modal: {
        size: 600,
        cssOverrides: {
            modalTitle: css`
                padding: 20px 30px;
            `,
        },
    },
    container: { gap: 10 },
    buttonsWrapper: {
        css: css`
            margin-top: 30px;
            text-align: right;
        `,
    },
    myActButton: {
        variant: "secondary",
    },
    editSubButton: {
        css: css`
            margin-right: 15px;
        `,
    },
    subscriptionModalHeading:{
        css: css`
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
        `
    },
    subscriptionNameGridItem:{
        css: css`
        width: 100%;
            max-width: 100%;
            flex-basis: auto;
    `
    },
}

const SubscriptionModal = ({extendedStyles, UserProfileId, CustomerId, isAuthenticated, getSubscriptionActiveData, isSubscriptionActiveFlag, isPunchOutSubFlag}:Props) =>{
    const [styles] = React.useState(() => mergeToNew(SubscriptionLinkStyles, extendedStyles));
    const subscriptionPopupMessage = siteMessage("Subscription_popup_msg");
    const subscriptionHeadingMessage = siteMessage("Subscription_popup_Headmsg");

    if(!isAuthenticated){
        return null;
    }

    if(isPunchOutSubFlag){
        return null;
    }

    React.useEffect(() => {
        getSubscriptionActiveData({
            CustomerId,
            UserProfileId,
        })
    }, []);
      
    const [modalIsOpen, setModalIsOpen] = React.useState(true);
    const history = useHistory();

    const modalCloseHandler = () => {
        setModalIsOpen(false);
        sessionStorage.setItem("subscriptionModalFlag",JSON.stringify(true));
    };

    const shareLinkClickHandler = () => {
        setModalIsOpen(true);
    };

    const addButtonClickHandler = () => {
        history.push("MyAccount");
        setModalIsOpen(false);
        sessionStorage.setItem("subscriptionModalFlag",JSON.stringify(true));
    };

    const editSubscriptionClickHandler = () =>{
        history.push("MyAccount/MySubscription");
        setModalIsOpen(false);
        sessionStorage.setItem("subscriptionModalFlag",JSON.stringify(true));
    }

    return(
        <>
        {isSubscriptionActiveFlag ? <>
            <Modal
                {...styles.modal}
                headline={subscriptionHeadingMessage}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                 <GridContainer {...styles.container} data-test-selector="subscriptionModal">
                 <GridItem {...styles.subscriptionNameGridItem}>
                 <Typography {...styles.subscriptionModalHeading}>{subscriptionPopupMessage}</Typography>
                    </GridItem>
                 </GridContainer>

                 <StyledWrapper {...styles.buttonsWrapper}>
                 <Button
                        {...styles.editSubButton}
                        onClick={editSubscriptionClickHandler}
                        data-test-selector="editSubscription"
                    >
                        {translate("Edit My Subscription")}
                    </Button>

                    <Button
                        {...styles.myActButton}
                        onClick={addButtonClickHandler}
                        data-test-selector="subscriptionSubmit"
                        // disabled={inProgress}
                    >
                        {translate("Go to My Account")}
                    </Button>
                 </StyledWrapper>

            </Modal>
        </> : null}
        </>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionModal);